import React, {memo} from 'react';
import {StaticImageData} from 'next/image';

import Container from '@/components/atoms/Container';
import OptimizedImage from '@/components/atoms/OptimizedImage';
import styles from './TrustedByStrip.module.scss';

// MUI-free copy of Ui-components/home/TrustedByStrip.

export interface TrustedByBrand {
    src: StaticImageData;
    alt: string;
    label: string;
}

export interface TrustedByStripProps {
    label?: string;
    brands: TrustedByBrand[];
}

const logoStyle: React.CSSProperties = {objectFit: 'contain'};

const TrustedByStrip = ({label = 'Featured in', brands}: TrustedByStripProps) => {
    return (
        <Container>
            <div className={styles.card}>
                <div className={styles.headerRow}>
                    <div className={styles.labelWrap}>
                        <div className={styles.dot} />
                        <p className={`font-headers ${styles.labelText}`}>{label}</p>
                    </div>
                </div>

                <div className={styles.divider} />

                <div className={styles.logoRow}>
                    {brands.map((brand) => (
                        <div key={brand.alt} className={styles.logoCell}>
                            <div className={`trusted-by-logo-img ${styles.logoImageWrap}`}>
                                <OptimizedImage src={brand.src} alt={brand.alt} fill style={logoStyle} />
                            </div>
                            <div className={`trusted-by-underline ${styles.underline}`} />
                        </div>
                    ))}
                </div>
            </div>
        </Container>
    );
};

export default memo(TrustedByStrip);
